import { Space, Spin } from 'antd';
import classNames from 'classnames';
import { useMemo } from 'react';
import Icon from '../../icons';
import { CustomButtonProps } from '../../interfaces';
import '../../styles.scss';
import { createNewWidthHeightStyle } from '../../utils';
import { CustomButtonWrapper } from './styles';
import './styles.scss';

const CustomButton: React.FC<CustomButtonProps> = props => {
  const {
    size,
    width,
    height,
    prefix,
    suffix,
    disabled,
    children,
    className,
    style = {},
    type = 'dark',
    loading = false,
    customRef,
    color,
    textColor,
    ...rest
  } = props;

  const newStyle = useMemo(() => {
    return { ...style, ...createNewWidthHeightStyle({ width, height }) };
  }, [width, height, style]);

  const Prefix = () => <div className="prefix">{prefix}</div>;
  const Suffix = () => <div className="suffix">{suffix}</div>;

  return (
    <CustomButtonWrapper
      {...rest}
      ref={customRef}
      size={size}
      style={
        !color && !textColor
          ? newStyle
          : {
              ...style,
              backgroundColor: color,
              color: textColor,
              border: `1px solid ${textColor}`,
              borderRadius: '16px',
            }
      }
      className={classNames([type], className, 'custom-btn')}
      disabled={disabled}
      loading={loading}
    >
      <Space
        className={classNames({ invisible: loading })}
        size={size === 'small' ? [4, 0] : [8, 0]}
      >
        {prefix && <Prefix />}
        {children}
        {suffix && <Suffix />}
      </Space>

      {loading && !disabled && (
        <Spin
          className="custom-spin"
          spinning={!!loading}
          indicator={<Icon name="loader" />}
        />
      )}
    </CustomButtonWrapper>
  );
};

export default CustomButton;
